import PrimaryButton from '../../atoms/Button';
import Text from '../../atoms/Text';
import ROUTES from '../../../shared/constants/routes';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, FileText } from '@phosphor-icons/react';

const BannerServiceStatus = () => {
	const navigate = useNavigate();
	return (
		<div		
			className='bg-h-primary-90 rounded-2xl px-4 py-3 flex items-center gap-2 cursor-pointer'
			onClick={() => navigate(ROUTES.SERVICE_STATUS)}
		>
			<div className='flex items-center justify-center'>
				<FileText
					size={24}
					weight='duotone'
				/>
			</div>

			<div className='w-full flex flex-col md:flex-row items-start md:justify-between gap-1 mt-0.5'>
				<Text
					weight='medium'
					size='caption'
					color='darkBlue'
				>
					Tienes declaraciones en proceso
				</Text>
				<PrimaryButton
					variant='text'
					label='Ver estado'
					labelSize='caption'
					labelColor='primary'
					onClick={() => navigate(ROUTES.SERVICE_STATUS)}
					icon={
						<ArrowRight
							size={20}
							color='#1772C2'
						/>
					}
				/>
			</div>
		</div>
	);
};

export default BannerServiceStatus;
